import { env } from "@/env";

import { SupportedChainId } from "./chains";

export const STRATOSPHERE_POINTS_PONDER_URL = {
	[SupportedChainId.AVALANCHE]: "https://wo8ss80.149.28.232.12.sslip.io/",
	[SupportedChainId.AVALANCHE_TESTNET]:
		"https://wo8ss80.149.28.232.12.sslip.io/",
} as const;

export const VAPORDEX_API_URL = env.NEXT_PUBLIC_API_URL;

export const GENESIS_SUBGRAPH_URL =
	"https://api.thegraph.com/subgraphs/name/vaporfi/genesis";
export const GRAPH_HEALTH = "https://api.thegraph.com/index-node/graphql";

export const VAPORDEX_V1_SUBGRAPH = {
	[SupportedChainId.AVALANCHE]:
		"https://api.goldsky.com/api/public/project_cloh4i8580dwo2nz7brhf4r6p/subgraphs/vapordex-v1-avalanche/1.0.0/gn",
	[SupportedChainId.APECHAIN]:
		"https://api.goldsky.com/api/public/project_cloh4i8580dwo2nz7brhf4r6p/subgraphs/vapordex-v1-apechain/1.0.1/gn",
	[SupportedChainId.CURTIS]:
		"https://apechain-curtis.vaporfi.dev/subgraphs/name/vapordex-v1-curtis",
	[SupportedChainId.SKALE_EUROPA_TESTNET]: "",
	[SupportedChainId.TELOS]:
		"https://api.goldsky.com/api/public/project_cloh4i8580dwo2nz7brhf4r6p/subgraphs/vapordex-v1-telos/1.0.1/gn",
	[SupportedChainId.TELOS_TESTNET]: "",
	[SupportedChainId.AVALANCHE_TESTNET]: "",
} as const satisfies Record<SupportedChainId, string>;

export const V2_SUBGRAPH_URLS = {
	[SupportedChainId.AVALANCHE]:
		"https://api.goldsky.com/api/public/project_cloh4i8580dwo2nz7brhf4r6p/subgraphs/vapordex-v2-avalanche/1.0.0/gn",
	[SupportedChainId.APECHAIN]:
		"https://api.goldsky.com/api/public/project_cloh4i8580dwo2nz7brhf4r6p/subgraphs/vapordex-v2-apechain/1.0.1/gn",
	[SupportedChainId.AVALANCHE_TESTNET]:
		"https://api.thegraph.com/subgraphs/name/thehitesh172/vapordex-v2-p",
	[SupportedChainId.CURTIS]:
		"http://107.178.106.170:8000/subgraphs/name/vapordex-v2-curtis",
	[SupportedChainId.SKALE_EUROPA_TESTNET]:
		"http://45.63.19.12:8000/subgraphs/name/vapordex-v2-europa",
	[SupportedChainId.TELOS]:
		"https://api.goldsky.com/api/public/project_cloh4i8580dwo2nz7brhf4r6p/subgraphs/vapordex-v2-telos/1.0.0/gn",
	[SupportedChainId.TELOS_TESTNET]:
		"https://api.goldsky.com/api/public/project_clp0zxiu2jk7a01w4ebwzcwlo/subgraphs/hit-v-t-t/1.0.0/gn",
} as const satisfies Record<SupportedChainId, string>;

export const TOKEN_FACTORY_SUBGRAPH_URLS = {
	[SupportedChainId.AVALANCHE]:
		"https://api.goldsky.com/api/public/project_cloh4i8580dwo2nz7brhf4r6p/subgraphs/token-factory-avalanche/1.0.0/gn",
	[SupportedChainId.AVALANCHE_TESTNET]:
		"https://api.goldsky.com/api/public/project_cloh4i8580dwo2nz7brhf4r6p/subgraphs/token-factory-fuji/1.0.0/gn",
} as const;

export const LIQUID_MINING_SUBGRAPH_URLS = {
	[SupportedChainId.AVALANCHE]:
		"https://api.goldsky.com/api/public/project_cloh4i8580dwo2nz7brhf4r6p/subgraphs/liquid-mining-avalanche/1.0.1/gn",
	[SupportedChainId.AVALANCHE_TESTNET]:
		// Keep the testnet subgraph for now, since testing is over
		"https://api.thegraph.com/subgraphs/name/royvardhan/liquid-mining",
} as const;

export const STAKING_SUBGRAPH_URLS = {
	[SupportedChainId.AVALANCHE]:
		"https://api.goldsky.com/api/public/project_cloh4i8580dwo2nz7brhf4r6p/subgraphs/vape-staking-avalanche/1.0.0/gn",
	[SupportedChainId.AVALANCHE_TESTNET]:
		"https://api.thegraph.com/subgraphs/name/royvardhan/xvape",
} as const;

export const MEME_FEES_DISTRIBUTION_URL = {
	[SupportedChainId.CURTIS]:
		"https://indexers-meme-fees-production.up.railway.app",
} as const;

export const APE_RUSH_INDEXER_URL = {
	[SupportedChainId.CURTIS]: "https://aperush-indexer.memelauncher.dev",
} as const;
